@if ((kind$ | async) === templateKind.Survey) {
  <app-survey-template-list></app-survey-template-list>
} @else {
  <app-sample-template-list></app-sample-template-list>
}
